import { render, staticRenderFns } from "./PlantVarietyDetail.vue?vue&type=template&id=2940bb0c&"
import script from "./PlantVarietyDetail.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports